import AboutSection from "../components/AboutSection";
import ImproveSkills from "../components/ImproveSkills";
import QuoteSection from "../components/QuoteSection";
import ChiefsSection from "../components/ChiefsSection";

export default function Home(){
    return (
        <div>
            <AboutSection/>
            <ImproveSkills/>
            <QuoteSection/>
            <ChiefsSection/>
        </div>
    )
}